import React, { useState, useEffect, useRef } from "react";

import { string, bool, func } from "prop-types";
import { itemShape } from "../prop-types.js";

import gsap from "gsap";
import cx from "classnames";
import * as R from "ramda";

const propTypes = {
  item: itemShape,
  position: string,
  activeFilter: string,
  isActive: bool,
  isFlipped: bool,
  onClickCard: func,
  onFlipCard: func,
};

const SliderCard = (props) => {
  const {
    item,
    position,
    activeFilter,
    isActive,
    isFlipped,
    onClickCard,
    onFlipCard,
  } = props;

  const [tabIndex, setTabIndex] = useState(-1);

  const buttonRef = useRef();

  useEffect(() => {
    if (isActive) {
      const parent = buttonRef.current.closest(".slick-slide");
      if (parent.classList.contains("slick-current")) {
        setTabIndex(0);
      }
    } else {
      setTabIndex(-1);
    }
  }, [isActive]);

  const tiltCard = (e) => {
    const card = e.currentTarget;
    const box = card.getBoundingClientRect();
    const centerPosition = {
      x: box.left + box.width / 2,
      y: box.top + box.height / 2,
    };
    let angle = Math.atan2(e.pageX - centerPosition.x, 0) * (25 / Math.PI);
    gsap.set(e.currentTarget, {
      "--card-rotation-offset": `${angle}deg`,
    });
  };

  const resetTilt = (e) => {
    gsap.set(e.currentTarget, { "--card-rotation-offset": "0deg" });
  };

  const activeProps = {
    onClick: () => onFlipCard(true),
    onPointerMove: tiltCard,
    onMouseLeave: resetTilt,
  };

  const defaultProps = {
    onClick: () => onClickCard(position),
  };

  return (
    <button
      type="button"
      ref={buttonRef}
      tabIndex={tabIndex}
      className={cx("slider-card", position, {
        flipped: isFlipped,
      })}
      {...(isActive ? activeProps : defaultProps)}
    >
      <div className="slider-card__front">
        <div className="slider-card__content">
          {item.title && <h3 className="slider-card__title">{item.title}</h3>}
          {!R.isEmpty(item.sectors) && (
            <div className="slider-card__tag-container">
              {item.sectors.map((sector) => (
                <span key={sector} className="slider-card__tag">
                  {sector}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </button>
  );
};

SliderCard.propTypes = propTypes;

export default SliderCard;
